import Industry from "./Industry"
import "./industry.css"

export default function IndustryInfoSection({ industryInfo }) {
 return (
  <div className="case-studies-container py-4">
   <Industry industryInfo={industryInfo} />
  </div>
 )
}